<template>
  <v-row dense>
    <v-col>
      <ReportHeading
        label="Звіт щодо заборгованості"
        :loading="loading"
        @update-report="getData"
      >
        <template v-slot:action>
          <DownloadFile
            location="xlsx"
            :params="reportData"
            filename="Звіт щодо заборгованості"
            extension="xlsx"
            tooltip="Завантажити у форматі Excel"
          />
        </template>
        <template v-slot:filters>
          <DebtFilter
            v-model="filter"
            :items="clients"
            :loading="loading"
            @input="setFilter(filter)"
          />
        </template>
      </ReportHeading>
      <Totals :source="filteredItems" />
      <v-card>
        <SimpleTable
          :headers="headers"
          :loading="loading"
          :items-per-page="filteredItems.length"
          :items="filteredItems"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SimpleTable from "@/components/story/SimpleTable";
import DebtFilter from "./Filter.vue";
import Totals from "./Totals.vue";
import * as reportsApi from "@/backend/reportsApi.js";
import DownloadFile from "@/components/DowloadFile.vue";
import ReportHeading from "@/components/ReportHeading.vue";
import { columnTypes, numberToString } from "@/helpers";

export default {
  components: {
    Totals,
    DebtFilter,
    SimpleTable,
    DownloadFile,
    ReportHeading,
  },
  data: () => ({
    loading: false,
    items: [],
    headers: [
      { text: "Клієнт", width: "60%", value: "client", type: "text" },
      { text: "Менеджер", width: "20%", value: "manager", type: "text" },
      {
        text: "Заборгованість, години",
        value: "balance",
        component: "ReportNumber",
        width: "20%",
      },
    ],
    filter: {
      onlyNegative: false,
      client: "",
      manager: null,
      date: "",
    },
  }),
  computed: {
    clients() {
      return this.items.map((i) => i.client);
    },
    filteredItems() {
      if (this.filter.onlyNegative) {
        return this.items.filter((item) => item.balance < 0);
      }
      if (this.filter.client) {
        return this.items.filter(
          (item) =>
            item.client.id === this.filter.client.id
        );
      }
      return this.items;
    },
    reportData() {
      return {
        columns: ["Клієнт", "Менеджер", "Заборгованість год."],
        rows: this.filteredItems.map((i) => {
          return [
            i.client.title,
            i.manager,
            numberToString(i.balance),
          ];
        }),
        columnTypes: [
          columnTypes.STRING,
          columnTypes.STRING,
          columnTypes.NUMBER,
        ],
      };
    },
  },
  watch: {
    filter(oldVal, newVal) {
      if (oldVal.manager?.id !== newVal.manager?.id || oldVal?.date !== newVal?.date) {
        this.getData();
      }
    },
  },
  created() {
    this.filter.date = this.moment().format("YYYY-MM-DD");
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      try {
        this.items = await reportsApi.debtGetData(this.filter?.manager?.id, this.filter?.date);
      } catch {
        this.$notifyWarning("В даних звіту помилки. Подивіться в Система/Стан БД");
      }
      this.loading = false;
    },
    setFilter(filter) {
      this.filter.onlyNegative = filter.onlyNegative;
      this.filter.client = filter.client;
      this.filter.manager = filter.manager;
      this.filter.date = filter.date;
    },
  },
};
</script>
